import { theme } from 'assets/themes/zizzi';
import { Typography, styled } from '@mui/material';
import { Color } from 'models';

const blue = theme.palette.primary.main;
const { white } = theme.palette;

interface ColorProps {
  type: Color;
}

const backgroundColor: Record<Color, string> = {
  dark: blue,
  light: white,
};

const textColor: Record<Color, string> = {
  dark: white,
  light: blue,
};

export const Text = styled(Typography)<ColorProps>`
  color: ${({ type }) => textColor[type]};
  font-size: 16px;
  margin-bottom: 0;

  ${theme.breakpoints.up('sm')} {
    font-size: 30px;
  }
`;

export const ListItemsContainer = styled('div')<ColorProps>`
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: ${theme.radius?.md};
  padding: 1rem;
  background: ${({ type }) => backgroundColor[type]};

  span {
    color: ${({ type }) => textColor[type]};
    font-family: 'Zizzi';
  }
`;
